import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
// redux
import { Provider } from 'react-redux';
// router
import { Route/*, Router, BrowserRouter*/ } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux'
// store
import store from 'store';

// import IndexPage from './examples/IndexPage';
// import SimpleForm from './examples/SimpleForm';
// import AdvancedFormPage from './examples/AdvancedFormPage';
// import UserFormPage from './examples/UserFormPage';

import IntlProvider from 'IntlProvider';
import { addLocaleData } from 'react-intl';
import intlLocaleRu from 'react-intl/locale-data/ru';
// import messages from './messages';

addLocaleData([...intlLocaleRu]);

ReactDOM.render(<Provider store={store}>
  <IntlProvider>
    <ConnectedRouter history={store.history}>
      <App/>
    </ConnectedRouter>
  </IntlProvider>
</Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js